



import Vue from 'vue'
import CreateRemittance from './CreateRemittance.vue'
export default Vue.extend({
  components: { CreateRemittance },
})
